// extracted by mini-css-extract-plugin
export default {"eventModal":"styles_event-modal_yDCB7","content":"styles_content_HxSXP","right":"styles_right_S1niY","left":"styles_left_uPoTi","border":"styles_border_QeAUe"};